<script setup lang="ts">
import { TabsContent, type TabsContentProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<TabsContentProps & { class?: string }>();
</script>

<template>
    <TabsContent
        :class="
            cn(
                'mt-2 ring-offset-white focus-visible:ring-stone-950 dark:ring-offset-stone-950 dark:focus-visible:ring-stone-300 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
                props.class,
            )
        "
        v-bind="props"
    >
        <slot />
    </TabsContent>
</template>
